"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function createAuthProvider(options) {
    const { tokenKey, userKey, loginAndGetSession } = options;
    const AuthContext = (0, react_1.createContext)(undefined);
    function useAuth() {
        const ctx = (0, react_1.useContext)(AuthContext);
        if (!ctx)
            throw new Error('useAuth must be used within AuthProvider');
        return ctx;
    }
    const AuthProvider = ({ children }) => {
        const [user, setUser] = (0, react_1.useState)(null);
        const [loading, setLoading] = (0, react_1.useState)(true);
        (0, react_1.useEffect)(() => {
            const token = localStorage.getItem(tokenKey);
            const saved = localStorage.getItem(userKey);
            if (token && saved) {
                try {
                    setUser(JSON.parse(saved));
                }
                catch {
                    localStorage.removeItem(tokenKey);
                    localStorage.removeItem(userKey);
                }
            }
            setLoading(false);
        }, []);
        const login = async (email, password) => {
            const session = await loginAndGetSession(email, password);
            if (!session)
                return false;
            localStorage.setItem(tokenKey, session.token);
            localStorage.setItem(userKey, JSON.stringify(session.user));
            setUser(session.user);
            return true;
        };
        const logout = () => {
            localStorage.removeItem(tokenKey);
            localStorage.removeItem(userKey);
            setUser(null);
        };
        return ((0, jsx_runtime_1.jsx)(AuthContext.Provider, { value: { user, isAuthenticated: !!user, loading, login, logout }, children: children }));
    };
    return { AuthProvider, useAuth };
}
exports.createAuthProvider = createAuthProvider;
